import React from "react";
import { Col, Row } from "reactstrap";
import styles from "./StatsCard.module.scss";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const StatsCard = ({ icon, title, thisMonth, overall, percentage, color }) => {
    return (
        <div className={styles.statsCard}>
            <div className={styles.cardBody}>
                <div className={styles.cardHeader}>
                    <img src={icon} alt={title} />
                    <h5 className={styles.cardTitle}>{title}</h5>
                </div>
                <div className={styles.cardContent}>
                    <Row className="m-0 mb-1 align-items-center">
                        <Col>This Month:</Col>
                        <Col className={styles.contentValue}>{thisMonth}</Col>
                    </Row>
                    <Row className="m-0 align-items-center">
                        <Col>Overall:</Col>
                        <Col className={styles.contentValue}>{overall}</Col>
                    </Row>
                </div>
                <Row className={styles.circularProgressBarRow}>
                    <Col>
                        <h2 className={styles.percentText}>{percentage}%</h2>
                    </Col>
                    <Col>
                        <CircularProgressbar
                            value={percentage}
                            strokeWidth={12}
                            styles={{
                                path: {
                                    stroke: color, // Set the path color
                                    strokeWidth: 12, // Set the width of the progress path (colored part)
                                },
                                trail: {
                                    stroke: color, // Set the trail color
                                    strokeWidth: 3, // Set the width of the trail (background part)
                                },
                                text: {
                                    fill: color,
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    textAnchor: "middle", // Center the text
                                    dominantBaseline: "middle", // Align the text vertically in the middle
                                },
                            }}
                        />
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default StatsCard;